'use client'

import React from 'react'

import { CampaignPopup } from '@definitions/types/storyblokTypes'

import StoryblokRichText from '@components/storyblok/atoms/StoryblokRichText'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@components/ui/Dialog'
import Image from 'next/image'
import Link from 'next/link'

import {
  dialogContentVariants,
  dialogBodyVariants,
  backgroundImageVariants,
  couponRichTextVariants,
  dialogTitleVariants,
  phoneImageVariants,
  footerWrapperVariants,
  dialogFooterVariants,
  footerTitleVariants,
  appStoreLinksVariants,
  appStoreImageVariants,
} from './index.styles'

interface CouponDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  campaignPopup: CampaignPopup
}

export function CouponDialog({
  open,
  onOpenChange,
  campaignPopup,
}: CouponDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={dialogContentVariants()}
        showCloseButton={true}
      >
        <div className={backgroundImageVariants()}>
          <Image
            src="/img/app/background-sunshine.png"
            width={100}
            height={100}
            alt="Background Sunshine"
            className="w-full h-full object-cover"
          />
        </div>
        <DialogBody className={dialogBodyVariants()}>
          <DialogTitle className="sr-only">Hinweis</DialogTitle>
          <div className={dialogTitleVariants()}>
            {campaignPopup.content ? (
              <StoryblokRichText
                content={campaignPopup.content}
                className={couponRichTextVariants()}
              />
            ) : null}
          </div>
          <div className={phoneImageVariants()}>
            <Image
              src="/img/app/phone-with-hand.png"
              width={1127}
              height={1267}
              alt="Coupons Body"
              className="w-full h-auto"
              quality={90}
            />
          </div>
        </DialogBody>
        <div className={footerWrapperVariants()}>
          <DialogFooter
            className={dialogFooterVariants()}
            showCloseButton={false}
          >
            <h2 className={footerTitleVariants()}>Jetzt herunterladen!</h2>
            <div className={appStoreLinksVariants()}>
              <Link
                href="https://apps.apple.com/de/app/sunpoint/id6451104302"
                target="_blank"
              >
                <div className={appStoreImageVariants()}>
                  <Image
                    src="/img/app/app-store.png"
                    width={200}
                    height={200}
                    alt="App Store"
                    className="w-full h-auto"
                  />
                </div>
              </Link>
              <Link
                href="https://play.google.com/store/apps/details?id=de.sunpoint.dk"
                target="_blank"
              >
                <div className={appStoreImageVariants()}>
                  <Image
                    src="/img/app/play-store.png"
                    width={200}
                    height={200}
                    alt="Google Play"
                    className="w-full h-auto"
                  />
                </div>
              </Link>
            </div>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
